import React, { useEffect, useState } from "react";
import EmailFilterModel from "../../core/api/email/EmailFilterModel";
import { EmailStatistics, StatisticsModel } from "../../core/api/statistics/StatisticsModel";
import { 
  DataGrid, 
  GridColDef 
} from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";

export interface TableProps {
  filter: EmailFilterModel;
}

function totalAccumulator(
  accumulator: EmailStatistics,
  currentValue: EmailStatistics
): EmailStatistics {
  return {
    createdByName: "Viso",
    count: accumulator.count + currentValue.count,
  };
}

const EmailStatisticsTable: React.FC<TableProps> = (props) => {
  const [data, setData] = useState<EmailStatistics[]>([]);
  
  useEffect(() => {
    const fetchData = async () => {
      const statistics = await StatisticsModel.getEmailStatistics(props.filter);
      if (statistics.length > 0) {
        const total = statistics.reduce(totalAccumulator, { createdByName: "Viso", count: 0 });
        setData([...statistics, total]);
      } else {
        setData([]);
      }
    };
    
    fetchData().catch(console.error);
  }, [props.filter]);

  // Prepare rows with IDs for DataGrid
  const rows = data.map((item, index) => ({
    ...item,
    id: index === data.length - 1 ? 'total' : `row-${index}`
  }));

  const columns: GridColDef[] = [
    { 
      field: "createdByName", 
      headerName: "Autorius", 
      flex: 1 
    },
    { 
      field: "count", 
      headerName: "Laiškų skaičius", 
      flex: 1,
      type: "number" 
    },
  ];

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100%', 
      bgcolor: 'background.paper',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box 
        sx={{ 
          p: 2, 
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f5f5f5', 
          fontWeight: 'bold',
          fontSize: '1.1rem',
          borderBottom: '1px solid #ddd'
        }}
      >
        <Typography variant="h6">
          {`Statistika nuo ${props.filter?.dateFrom || ''} iki ${props.filter?.dateTo || ''}`}
        </Typography>
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        hideFooter
        getRowClassName={(params) => 
          params.id === 'total' ? 'total-row' : params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'
        }
        sx={{
          border: 'none',
          '& .total-row': {
            backgroundColor: '#e0e0e0',
            fontWeight: 'bold',
          },
          '& .even-row': {
            backgroundColor: '#ffffff',
          },
          '& .odd-row': {
            backgroundColor: '#efefef',
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#bdbdbd',
          },
          '& .MuiDataGrid-virtualScroller': {
            minHeight: '200px',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .MuiDataGrid-row': {
            borderBottom: '1px solid',
            borderColor: 'divider',
          },
        }}
        slots={{
          noRowsOverlay: () => (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
              Laiškų statistikos nėra
            </Box>
          ),
        }}
      />
    </Box>
  );
};

export default EmailStatisticsTable;
